// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Stuw0","leftSection":"styles_leftSection__nE0Ww"};